/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_024: Question = {
  id: 'pres-024-diversite-milieux-humides',
  oldId: '38',
  title: 'Diversité des milieux humides',
  number: '3.8',
  description: ['Indice de diversité de Shannon appliqué à la classe de milieux humides'],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

const question_pres_024__v3: Question = {
  ...question_pres_024,
  number: '3.2',
  frequency: 4,
};

export const question_pres_024_v2: Question = question_pres_024;
export const question_pres_024_v3: Question = question_pres_024__v3;
